const JOURNEY_STORAGE_PREFIX = "robotrader_journey_intent";

const getUserId = (userData = null) => {
    if (userData?.user?.userId) {
        return userData.user.userId;
    }

    try {
        const raw = localStorage.getItem("userData");
        const storedUserData = raw ? JSON.parse(raw) : null;
        return storedUserData?.user?.userId || "guest";
    } catch (error) {
        return "guest";
    }
};

export const getJourneyIntentKey = ({ appId = "app", userData = null } = {}) => {
    return `${JOURNEY_STORAGE_PREFIX}:${appId || "app"}:${getUserId(userData)}`;
};

export const getAppJourneyIntentKey = ({ appId = "app" } = {}) => {
    return `${JOURNEY_STORAGE_PREFIX}:${appId || "app"}`;
};

export const getJourneyIntent = ({ appId = "app", userData = null } = {}) => {
    try {
        const value = localStorage.getItem(getJourneyIntentKey({ appId, userData }))
            || localStorage.getItem(getAppJourneyIntentKey({ appId }));
        return ["mentor", "student"].includes(value) ? value : null;
    } catch (error) {
        return null;
    }
};

export const setJourneyIntent = ({ appId = "app", userData = null, intent }) => {
    if (!["mentor", "student"].includes(intent)) {
        return;
    }

    localStorage.setItem(getAppJourneyIntentKey({ appId }), intent);

    if (getUserId(userData) !== "guest") {
        localStorage.setItem(getJourneyIntentKey({ appId, userData }), intent);
    }
};

export const clearJourneyIntent = ({ appId = "app", userData = null } = {}) => {
    localStorage.removeItem(getJourneyIntentKey({ appId, userData }));
    localStorage.removeItem(getAppJourneyIntentKey({ appId }));
};

export const getJourneyPath = (intent) => {
    if (intent === "mentor") {
        return "/welcome/mentor";
    }

    if (intent === "student") {
        return "/welcome/student";
    }

    return "/welcome";
};
